import { type ReactNode, type PropsWithChildren } from 'react'

import styles from './CollectionContentLayout.module.css'

type TCollectionContentLayoutProps = PropsWithChildren<{ sidebar: ReactNode }>

/**
 * Two-column region below the hero: a fixed 19.5rem sidebar (left on desktop) + a growing content
 * column. On mobile the content stacks above the sidebar.
 */
export const CollectionContentLayout = ({ sidebar, children }: TCollectionContentLayoutProps) => (
    <div className={styles.layout}>
        <section className={styles.sidebar}>
            <aside className={styles.suggestions}>{sidebar}</aside>
        </section>
        <section className={styles.content}>{children}</section>
    </div>
)
